import { useQuery } from '@tanstack/react-query'
import http from '@/lib/http'

export type ProductCategory = {
  hash: string
  name: string
  parentHash: string | null
}

export const useProductCategoryTree = () =>
  useQuery<ProductCategory[]>({
    queryKey: ['productCategoryTree'],
    queryFn: () => http.get<ProductCategory[], ProductCategory[]>('/products/categories/tree'),
    staleTime: Number.POSITIVE_INFINITY
  })
